import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { ButtonComponent } from '@libs/common/components';
import { CapacitorService } from '@libs/shared/common';
import { AppUpdateDialogConfig } from '@libs/shared/models';

const DEFAULT_DIALOG_CONFIG: AppUpdateDialogConfig = {
  title: 'Aktualisierung erforderlich',
  // eslint-disable-next-line max-len
  text: 'Die von Ihnen verwendete App-Version wird nicht mehr unterstützt. Bitte aktualisieren Sie die App, um weiterhin alle Funktionen uneingeschränkt, sicher und zuverlässig nutzen zu können.',
  showCloseButton: false,
};

@Component({
  selector: 'ui-app-update-dialog-form',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    ButtonComponent,
  ],
  templateUrl: './app-update-dialog-form.component.html',
  styleUrls: [
    './app-update-dialog-form.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateDialogFormComponent {
  public readonly config: AppUpdateDialogConfig = inject<AppUpdateDialogConfig | null>(MAT_DIALOG_DATA, { optional: true }) ?? DEFAULT_DIALOG_CONFIG;

  private readonly capacitorService: CapacitorService = inject(CapacitorService);

  public async startAppUpdateFlow(): Promise<void> {
    await this.capacitorService.startNativeAppUpdateFlow();
  }
}
